/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import BugifyLayout from "./layout";
import AuthComponent from "./auth/login";

import { setUserData } from "../utils/redux/actions";

import "./App.scss";

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userData } = useSelector((state) => {
    return state?.app;
  });

  const savedUserData = JSON.parse(localStorage.getItem("bugify-user-data"));

  useEffect(() => {
    dispatch(setUserData(savedUserData));
  }, []);

  const isLoggedIn = !!savedUserData?.token || !!userData?.token;

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/projects");
    }
  }, [isLoggedIn]);

  return (
    <div className="bugify-main-container">
      {isLoggedIn ? (
        <BugifyLayout />
      ) : (
        <Routes>
          <Route path="/login" element={<AuthComponent />} />
        </Routes>
      )}
    </div>
  );
};

export default App;
